import { localized } from '@/i18n/localize'
export const subscriptionStrings = localized({
  upgradeInProgress: (plan: string) => `Your ${plan} upgrade is being processed`,
  view: 'View',
  title: 'Subscription',
  currentPlan: 'Current plan',
  renewsOn: (date: string) => `Renews ${date}`,
  // LP-536: the same sentences as the mobile app's subscriptionSwitchesOn / subscriptionSwitchScheduled / subscriptionScheduledBadge.
  switchesOn: (plan: string, date: string) => `Switches to ${plan} on ${date}`,
  switchScheduled: (plan: string, date: string) => `Your plan will switch to ${plan} on ${date}`,
  switchScheduledDesc: 'Your current plan stays active until then.',
  scheduledBadge: 'Scheduled',
  noActivePlan: 'You are not on a plan yet',
  noActivePlanDesc: 'Properties and rent tracking are free and unlimited without a plan. A plan changes what it costs to start a new lease.',
  usage: 'Your usage',
  activeLeases: (n: number) => (n === 0 ? 'No active leases' : n === 1 ? '1 active lease' : `${n} active leases`),
  propertiesFree: 'Properties are unlimited and free on every plan. You are billed per lease.',
  planLeaseFee: 'Lease fee (1 year)',
  nextLeaseCost: 'Your next 1-year lease',
  nextLeaseFree: 'Free',
  nextLeaseUsesFree: 'Uses one of your free leases',
  perLeaseNote: 'Charged once per lease, per year of its term.',
  comparePlans: 'Other plans',
  changePlanDesc: 'Plans differ in what a lease costs to activate, not in how many properties you can manage.',
  plansNotFound: 'No other plans available right now',
  manageBilling: 'Manage billing',
  paddleBilledNote: 'Your plan is billed through Paddle, which handles card changes, cancellation and invoices.',
  portalFailed: "Couldn't open billing. Try again in a minute.",
  currentBadge: 'Current',
  switchTo: (plan: string) => `Switch to ${plan}`,
  planFree: 'Free',
  monthly: 'Monthly',
  yearly: 'Yearly',
  checkoutTitle: 'Confirm your plan',
  checkoutPlan: 'Plan',
  checkoutBilling: 'Billing',
  checkoutDueToday: 'Due today',
  confirmUpgrade: 'Confirm Upgrade',
  updateConfirmation: "By clicking 'Confirm Upgrade', you authorize this change. The new plan takes effect immediately and your subscription is adjusted accordingly.",
  encryptedNote: 'All transactions are secure and encrypted',
  activatingTitle: 'Activating your subscription',
  activatingDesc: 'This can take a minute. Your plan updates as soon as it is done.',
  activated: 'Your plan is active',
  activatedDesc: 'The new lease pricing applies from your next lease.',
  updateError: 'Could not update your plan. Please try again.',
  activationFailed: 'This subscription will be cancelled and the amount refunded if it was deducted from your account.',
  checkoutFailed: 'Payment was cancelled or could not be completed',
  checkoutNotActive: 'The plan did not activate. If money was deducted it will be refunded.',
  pendingTitle: (plan: string) => `A change to ${plan} is still being processed`,
  pendingDesc: 'It activates as soon as the payment is confirmed. You can cancel it if you did not mean to start it.',
  cancelPending: 'Cancel pending change',
  cancelPendingTitle: 'Cancel the pending plan change?',
  cancelPendingMessage: 'The payment will be voided; any amount deducted is refunded by the gateway.',
  cancelPendingConfirm: 'Cancel change',
  keepIt: 'Keep it',
  pendingCancelled: 'Pending change cancelled',
  somethingWentWrong: 'Something went wrong',
  features: 'Included',
  publishListing: 'Public listing',
  freeLeases: (n: number) => (n === 1 ? '1 free lease' : `${n} free leases`),
  plansTitle: 'Plans',
  compareTitle: 'Compare plans',
  compareCaption: 'What each plan includes',
  colFeature: 'Feature',
  rowPrice: 'Plan price',
  rowLeaseFee1: 'Lease fee, 1-year lease',
  rowLeaseFee3: 'Lease fee, 3-year lease',
  rowFreeLeases: 'Free leases',
  rowPublic: 'Public listing',
  rowProperties: 'Properties',
  unlimited: 'Unlimited',
  included: 'Included',
  notIncluded: 'Not included',
  kpiPlan: 'Plan',
  kpiNoPlan: 'No plan',
  kpiActiveLeases: 'Active leases',
  kpiLeaseFee: 'Lease fee',
  kpiPerYear: 'per lease, per year',
  kpiNextLease: 'Next lease',
  kpiNextLeaseHint: '1-year lease',
  billingTitle: 'Billing history',
  billingCaption: 'Plan payments and lease fees',
  billingEmpty: 'No plan payments or lease fees yet',
  billingAll: 'All transactions',
  colDate: 'Date',
  colFor: 'For',
  colMethod: 'Method',
  colAmount: 'Amount',
  colStatus: 'Status',
  perPeriod: (unit: string) => `/ ${unit}`,
  currentPlanBadge: 'Current plan',
})
